'use strict'

import elementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import HelpTooltipManager from 'assets/core/js/module/helpTooltipManager'
import common from 'assets/themes/campings/js/page/common/index'

import type { Calendar as SearchCalendarType } from '@ui/Search/Calendar/component'

export default function (): void {
  const helpTooltip = HelpTooltipManager.getHelpTooltip('search-checkInDate')
  const dateInputEl = document.querySelector<HTMLElement>(`#search_offers_checkInDate`)

  if (!dateInputEl || !helpTooltip) {
    return
  }

  const calendar = elementPropertiesManager.getProperty<SearchCalendarType>(dateInputEl, 'calendar')

  if (!calendar) {
    return
  }

  helpTooltip.close()

  const inputEl = calendar.input

  calendar.config.callbacks?.onOpen?.push(() => {
    if (!common.isMobile() && !common.isTablet()) {
      helpTooltip.close()
    }
  })

  if (inputEl.value === '') {
    helpTooltip.open()
  }
}
